import Link from "next/link";
import { useRouter } from "next/router";
import type { FunctionComponent } from "react";

import { Container, Tab } from "./styles";

export const PlusArchiveFilterTabs: FunctionComponent = () => {
  const { pathname } = useRouter();
  const isArchive = pathname.includes("/plus/archive");
  const isCft = pathname.includes("/plus/cft");

  return (
    <Container>
      <Tab $active={isArchive}>
        <Link href="/plus/archive">All</Link>
      </Tab>
      <Tab $active={isCft}>
        <Link href="/plus/cft">China Future Tech</Link>
      </Tab>
    </Container>
  );
};

PlusArchiveFilterTabs.displayName = "PlusArchiveFilterTabs";
